import {
  BatchCollectionMgmtBibColBulkRemovalConditionListItem,
  BatchCollectionMgmtBibColBulkRemovalConditionListItemFromJSON
} from '@/api/models/batch/BatchCollectionMgmtBibColBulkRemovalConditionListItem'

export interface BatchCollectionMgmtBibColBulkRemovalPageLoadResult {
  items: BatchCollectionMgmtBibColBulkRemovalConditionListItem
}

export function BatchCollectionMgmtBibColBulkRemovalPageLoadResultFromJSON(
  json: any
): BatchCollectionMgmtBibColBulkRemovalPageLoadResult {
  return {
    items: BatchCollectionMgmtBibColBulkRemovalConditionListItemFromJSON(json)
  }
}
